import { z } from "zod";

const eventTypeValues = [
	"Unknown",
	"MachineGroupStatus",
	"ImportedStatus",
	"StagedStatus",
	"SelectedStatus",
	"ProducedStatus",
	"RetractedStatus",
	"ImportFailedStatus",
	"StagingFailedStatus",
	"CartonizedStatus",
	"CartonizeFailedStatus",
	"ImportIgnoredStatus",
	"RemovedStatus",
	"ClosingRequiredStatus",
	"ClosingStatus",
	"ClosedStatus",
	"ClosingFailedStatus",
	"ClosedManuallyStatus",
	"ClosingRemovedStatus",
	"ClosingExpiredStatus",
	"CompletedStatus",
	"MachineStopReason",
] as const;

export const eventTypeSchema = z.enum(eventTypeValues);
export type EventType = z.infer<typeof eventTypeSchema>;
